import { useState, useEffect } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Link } from '@vk-hr-tek/ui/Link';
import { CardMedia } from '@vk-hr-tek/ui/CardMedia';
import { Skeleton } from '@vk-hr-tek/ui/Skeleton';
import { NoImage } from '@vk-hr-tek/app-ui/NoImage';

import { modules } from '@app/modules';

import { ImageParams, SearchNewsOption } from '../SearchInput.types';
import { useUrlWithPrefix } from '../../../../hooks';

import { SearchOptionMeta } from './SearchOptionMeta';

interface SearchOptionNewsProps {
  option: SearchNewsOption;
  loadImage: (params: ImageParams) => Promise<string>;
}

export const SearchOptionNews = ({
  option,
  loadImage,
}: SearchOptionNewsProps) => {
  const [src, setSrc] = useState('');
  const urlWithPrefix = useUrlWithPrefix();
  const href = `/${modules.news.basename}/${option.id}`;
  const [isImgLoading, setImgLoading] = useState(false);

  useEffect(() => {
    if (option.cover_att_id) {
      setImgLoading(true);
      loadImage({ id: option.cover_att_id }).then(
        (url) => {
          setSrc(url);
          setImgLoading(false);
        },
        () => {
          setImgLoading(false);
        },
      );
    }
  }, [loadImage, option.cover_att_id]);

  const foundedImg =
    !isImgLoading && src === '' ? (
      <NoImage />
    ) : (
      <CardMedia
        component="img"
        src={src}
        alt={option.title}
        width="100%"
        height="100%"
      />
    );

  const labels = [{ label: option.category, isShrink: true }];

  return (
    <Box width="100%" p="8">
      <Link {...urlWithPrefix(href)} variant="simple" display="block">
        <Box width="100%" display="flex" gap="12">
          <Box
            radius="s"
            overflow="hidden"
            minHeight="40px"
            minWidth="40px"
            height="40px"
            width="40px"
          >
            {isImgLoading ? (
              <Skeleton variant="rect" radius="s" width="100%" height="100%" />
            ) : (
              foundedImg
            )}
          </Box>
          <Box
            flex={1}
            display="flex"
            flexDirection="column"
            gap="2"
            maxHeight="60px"
          >
            <SearchOptionMeta labels={labels} date={option.date} />
            <Box>
              <Typography
                maxLinesCount={2}
                variant="body3"
                color="text.light.primary"
                wordBreak="break-all"
              >
                {option.title}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Link>
    </Box>
  );
};
